<template>
  <base-nav v-model="showMenu" class="navbar-absolute top-navbar" type="white" :transparent="true">
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline">
        <sidebar-toggle-button />
      </div>
      <div class="navbar-toggle d-inline" :class="{ toggled: $sidebar.showSidebar }">
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <!-- <a class="navbar-brand">{{ routePath }}</a> -->
      <route-bread-crumb />
    </div>

    <div class="navbar-nav ml-auto"></div>

    <div class="navbar-nav ml-auto">
      <base-alert v-if="diffDays !== ''" :type="diffDays === '7' ? 'warning' : 'danger'">{{
        diffDays === '7' ? 'El certificado expira en menos de 7 días' : 'Certificado Expirado. La facturación se ha bloqueado'
      }}</base-alert>

      <base-alert v-if="$store.state.latest" type="info"
        >Hola, tenemos una nueva versión: {{ $store.state.latest }}
        <base-button class="menu-btn" type="primary" @click="update()"> Actualizar </base-button>
      </base-alert>

      <div v-if="emisor.id && $session.user.profile !== 'COMMUNITY'">
        <base-alert v-if="$session.gracePeriod && $session.subscription" type="info">
          Estás en periodo de pago. Te quedan {{ graceDays }} días para
          <base-button class="menu-btn" type="primary" @click="gotoPayment()"> Pagar </base-button>
        </base-alert>

        <base-alert v-if="!$session.subscription" type="danger">
          Suscripción vencida.
          <base-button class="menu-btn" type="info" @click="gotoPayment()"> Pagar </base-button>
        </base-alert>
      </div>

      <base-alert v-if="$session.counter !== null && getCounter <= 10" type="info">
        Te quedan {{ getCounter }} facturas disponibles este mes
        <base-button class="menu-btn" type="danger" @click="gotoPayment()"> Comprar </base-button>
      </base-alert>
    </div>

    <div class="navbar-nav ml-auto">
      <el-select
        v-show="showPageSelector"
        v-model="page"
        ref="refPageSelector"
        :class="$darkMode.selectClass()"
        filterable
        autocomplete
        placeholder="Seleccione la Página"
        @focus="$event.target.select()"
        @change="showPage">
        <el-option v-for="(path, i) in paths" :key="i" :value="path.value" :class="$darkMode.selectClass()" :label="path.label"></el-option>
      </el-select>

      <!-- {{ menu }} -->
      <template v-if="lastMenu && lastMenu.length">
        <base-dropdown v-if="allMenu.length > 4" class="dropdown btn-group">
          <template slot="title-container" slot-scope="{ isOpen }">
            <base-button
              type="info"
              simple
              class="dropdown-toggle dropdown-toggle-split menu-btn"
              data-toggle="dropdown"
              aria-haspopup="true"
              :aria-expanded="isOpen"
              >Menu
              <span class="sr-only">Toggle Dropdown</span>
            </base-button>
          </template>

          <!-- <a class="dropdown-item" @click="showCheck(true)">Eliminar</a> -->
          <a v-for="(m, i) in allMenu.slice(4)" :key="i" class="dropdown-item" @click="$router.push(m.path)">
            {{ m.page }}
          </a>
        </base-dropdown>

        <base-button v-for="(m, i) in lastMenu" :key="i" :simple="!m.isActive" class="menu-btn" type="info" @click="$router.push(m.path)">
          {{ m.page }}
        </base-button>
      </template>
    </div>

    <div class="navbar-nav ml-auto">
      <base-alert v-if="diffDays !== ''" :type="diffDays === '7' ? 'warning' : 'danger'">{{
        diffDays === '7' ? 'El certificado expira en menos de 7 días' : 'Certificado Expirado. La facturación se ha bloqueado'
      }}</base-alert>
    </div>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <base-dropdown v-if="cajaSesion._id" tag="li" :menu-on-right="!$rtl.isRTL" title-tag="a" title-classes="nav-link" class="nav-item">
        <template slot="title">
          <div class="notification d-none d-lg-block d-xl-block"></div>
          <i class="tim-icons icon-coins"></i>
        </template>
        <!-- <li v-for="obj in unSavedObjects" :key="obj.objectName" class="nav-link">
          <router-link :to="{ path: obj.routePath }">
            <a class="nav-item dropdown-item">{{ obj.message }}</a>
          </router-link>
        </li> -->
        <a class="nav-item dropdown-item text-center">Caja Abierta</a>
        <a class="nav-item dropdown-item text-center">{{ cajaSesion?.caja?.name }}</a>
        <div class="dropdown-divider"></div>

        <a class="nav-item dropdown-item text-center">{{ $toolkit.getTimeAgo(cajaSesion.createdAt) }}</a>
        <a class="nav-item dropdown-item text-center">{{ cajaSesion.userSession.fullname }}</a>
      </base-dropdown>

      <!-- NOTIFICACIONES DOCUMENTOS SIN GUARDAR -->
      <base-dropdown v-if="unSavedObjects.length !== 0" tag="li" :menu-on-right="!$rtl.isRTL" title-tag="a" title-classes="nav-link" class="nav-item">
        <template slot="title">
          <div class="notification d-none d-lg-block d-xl-block"></div>
          <i class="tim-icons icon-attach-87"></i>
          <p class="d-lg-none">Documentos sin Guardar</p>
        </template>
        <li v-for="obj in unSavedObjects" :key="obj.objectName" class="nav-link">
          <router-link :to="{ path: obj.routePath }">
            <a class="nav-item dropdown-item">{{ obj.message }}</a>
          </router-link>
        </li>
      </base-dropdown>

      <!-- TODO: MODAL DE BUSQUEDAS de MANUALES -->
      <!-- <div class="search-bar input-group" @click="searchModalVisible = true">
        <input type="text" class="form-control" placeholder="Search..." />
        <div class="input-group-addon"><i class="tim-icons icon-zoom-split"></i></div>

        <button id="search-button" class="btn btn-link" data-toggle="modal" data-target="#searchModal">
          <i class="tim-icons icon-zoom-split"></i>
        </button>
        You can choose types of search input
      </div>

      <modal id="searchModal" :show.sync="searchModalVisible" class="modal-search" :centered="false" :show-close="true" :close-outside="true">
        <input id="inlineFormInputGroup" slot="header" v-model="searchQuery" type="text" class="form-control" placeholder="SEARCH" />
      </modal> -->

      <!-- TODO: notificaciones para el usuario -->
      <!-- <base-dropdown tag="li" :menu-on-right="!$rtl.isRTL" title-tag="a" title-classes="nav-link" class="nav-item">
        <template slot="title">
          <div class="notification d-none d-lg-block d-xl-block"></div>
          <i class="tim-icons icon-bell-55"></i>
          <p class="d-lg-none">New Notifications</p>
        </template>
        <li class="nav-link">
          <a href="#" class="nav-item dropdown-item">Bienvenido a JIT</a>
        </li>
      </base-dropdown> -->

      <!-- TODO: menu de usuario -->
      <base-dropdown tag="li" :menu-on-right="!$rtl.isRTL" title-tag="a" class="nav-item" title-classes="nav-link" menu-classes="dropdown-navbar">
        <template slot="title">
          <div class="photo">
            <!-- TODO: imagen del usuario, temporalmente muestra boton -->
            <!-- <img src="img/mike.jpg" /> -->
            <font-awesome-icon :icon="['fa', 'user']" size="lg" />
          </div>
          <b class="caret d-none d-lg-block d-xl-block"></b>

          <p class="d-lg-none">Usuario</p>
        </template>
        <!-- <router-link> -->
        <!-- <li class="nav-link">
          <a class="nav-item dropdown-item">Profile</a>
        </li>-->
        <!-- </router-link> -->
        <!-- <router-link> -->
        <!-- <li class="nav-link">
          <a class="nav-item dropdown-item">Settings</a>
        </li>-->
        <!-- </router-link> -->

        <li class="nav-link">
          <a class="nav-item dropdown-item"
            >{{ $session.user.fullname ? $session.user.fullname.split(' ')[0] : 'Usuario' }}({{ $session.user.profile || 'COMMUNITY' }})</a
          >
        </li>

        <div class="dropdown-divider"></div>

        <div class="togglebutton switch-change-color ml-3">
          <span class="label-switch label-right">Oscuro</span>
          <base-switch v-model="darkMode" class="mt-2" @input="toggleMode"></base-switch>
        </div>

        <div class="togglebutton switch-change-color ml-3">
          <span class="label-switch label-right">Notifica</span>
          <base-switch v-model="notifications" class="mt-2" @input="subscribe"></base-switch>
        </div>
        <div class="dropdown-divider"></div>
        <!-- <router-link to="/userProfile">
          <li class="nav-link">
            <a class="nav-item dropdown-item">Perfil</a>
          </li>
        </router-link>-->
        <li class="nav-link" @click="logout">
          <a class="nav-item dropdown-item">Salir</a>
        </li>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
/* eslint-disable no-undef */
import { CollapseTransition } from 'vue2-transitions'
import { mapState } from 'vuex'
import { BaseNav, Modal, BaseSwitch, BaseAlert } from '@/components'
import SidebarToggleButton from './SidebarToggleButton.vue'
import { Session } from '@/plugins/session'
import { RouteBreadCrumb } from '@/components'
import { Select, Option } from 'element-ui'
import { state } from '~/store/facturacion/types/tipoIdentificacion'

export default {
  components: {
    SidebarToggleButton,
    BaseSwitch,
    // eslint-disable-next-line vue/no-unused-components
    CollapseTransition,
    BaseNav,
    RouteBreadCrumb,
    Modal,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      page: null,

      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      sidebarMini: true,
      Session,
      darkMode: null,
      notifications: false,
      diffDays: '',
      paths: this.$toolkit.paths.filter(e => e.value !== 'nulo')
    }
  },

  computed: {
    ...mapState({
      certificadoExpiracion: state => state.facturacion.emisorStore.emisor.certificadoExpiracion,
      emisorSaved: state => state.facturacion.emisorStore.saved,
      emisor: state => state.facturacion.emisorStore.emisor,
      facturaSaved: state => state.facturacion.facturaStore.saved,
      mensajeReceptorSaved: state => state.facturacion.mensajeReceptorStore.saved,
      cajaSesion: state => state.facturacion.facturaStore.cajaSesion,

      menu: state => state.menu
    }),

    showPageSelector() {
      return this.$store.state.pageSelector
    },

    graceDays() {
      let subsDate = new Date(this.$session.subscriptionTimeOut)
      subsDate.setDate(subsDate.getDate() + 3)

      var timeDiff = Math.abs(subsDate.getTime() - new Date().getTime())

      // Calculate the number of days
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

      return diffDays <= 3 ? diffDays : 0
    },

    getCounter() {
      return this.$session.getCurrentCounter()
    },

    unSavedObjects() {
      const unSaved = []
      if (!this.emisorSaved) unSaved.push({ objectName: 'emisor', message: 'Emisor sin guardar', routePath: '/emisor/datosatv' })
      if (!this.facturaSaved) unSaved.push({ objectName: 'factura', message: 'Factura sin guardar', routePath: '/facturacion/facturar' })
      // if (!this.mensajeReceptorSaved)
      //   unSaved.push({ objectName: 'MensajeReceptor', message: 'Aceptar comprobante sin guardar', routePath: '/mensajeReceptor' })

      // if (this.unSaved.length !== 0) this.hasUnSavedObjects = true
      return unSaved
    },
    routePath() {
      const { name } = this.$route
      return this.capitalizeFirstLetter(name.split('_')[0])
    },
    isRTL() {
      return this.$rtl.isRTL
    },

    lastMenu() {
      const myMenu = this.menu && this.menu.length ? this.menu.slice(-4) : []

      return myMenu
    },
    allMenu() {
      // return this.menu descendente
      const myMenu = this.menu && this.menu.length ? this.menu.slice().reverse() : []

      return myMenu
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    '$session.state': function () {
      if (!this.$session.state) this.$router.push('/Logout')
    },
    showPageSelector(val) {
      if (val) this.$nextTick(() => this.$refs.refPageSelector.focus())
    }
  },
  mounted() {
    this.darkMode = this.$darkMode.get()
    this.checkCert()

    // debe esperar unos segundos mientras toma el valor.
    setTimeout(() => {
      this.notifications = this.$OneSignal.Notifications.permission && this.$OneSignal.User.PushSubscription.optedIn
    }, 5000)
  },

  methods: {
    gotoPayment() {
      if (this.$session.user.subprofile) this.$router.push('/accountDisabled')
      else this.$router.push('/pricing')
    },
    showPage(val) {
      const route = this.paths.find(item => item.value === val)
      this.paths = this.paths.filter(item => item.value !== val)
      this.paths = [route, ...this.paths]

      this.$router.push(val)
      this.$store.commit('SHOW_PAGE_SELECTOR', false)
      this.page = null
    },
    checkCert() {
      this.diffDays = this.$toolkit.checkCert(this.certificadoExpiracion)
    },
    toggleMode(type) {
      this.$darkMode.set(type)
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize()
    },
    async logout() {
      this.$router.push('/logout')
    },
    update() {
      window.location.reload()
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown() {
      this.activeNotifications = false
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false)
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    subscribe() {
      this.$swNotification.subscribe(this.emisor.id, this.$session.user.email)
    }
  }
}
</script>
<style scoped>
.top-navbar {
  top: 0px;
}

.menu-btn {
  padding: 10px 22px !important;
}
</style>
